<template>
    <div style="height: 100%">
        <div class="chart" ref="chartdiv"></div>
    </div>
</template>

<script>

    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import themeDark from "@amcharts/amcharts4/themes/dark";

    am4core.useTheme(themeDark);

    export default {

        props: ['name'],

        data() {
            return {
                chart: null,
                chartsLib: null,
            }
        },

        mounted() {
            this.loadData();
        },

        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose();
            }
        },

        computed: {
            ...mapState('DashBoard', [
                'chartLoading',
                'panelSizeStats'
            ]),
        },

        methods: {

            setData() {
                if (this.chart) this.chart.data = this.panelSizeStats;
            },

            createChart() {

                let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

                chart.paddingRight = 5;
                chart.paddingLeft = 0;
                chart.paddingBottom = 0;
                chart.paddingTop=10;

                chart.data = this.panelSizeStats;
                chart.cursor = new am4charts.XYCursor();

                chart.colors.list = [
                    am4core.color("#315bf7"),
                    am4core.color("#D65DB1"),
                    am4core.color("#FF6F91"),
                    am4core.color("#FF9671"),
                    am4core.color("#FFC75F"),
                    am4core.color("#F9F871")
                ];

                let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.dataFields.category = "id";


                let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.tooltip.disabled = true;
                valueAxis.renderer.minWidth = 25;

                let series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.categoryX = "id";
                series.dataFields.valueY = "count";
                series.tooltipText = "{valueY.value}";
                series.columns.template.fillOpacity = 0.5;
                series.showOnInit = false;

                let series2 = chart.series.push(new am4charts.LineSeries());
                series2.dataFields.categoryX = "id";
                series2.dataFields.valueY = "count";
                series2.strokeWidth = 3;
                series2.stroke = am4core.color("#FFC75F");
                series2.strokeOpacity = 0.7;
                series2.tensionX = 0.8;
                series2.tensionY = 0.8;
                series2.showOnInit = false;

                this.chart = chart;
            },

            loadData(force = false) {

                this.$emit('loading-started');

                this.$store.dispatch('DashBoard/getPanelSizeStats', force)
                    .then(() => {
                        this.$emit('loading-ended');

                        if (this.chart===null) this.createChart();
                        this.setData();
                    })
                    .catch(error => {
                        Bus.$emit('flash-message', {type: 'error', message: 'Panel growth statistics failed to load!'});
                        this.$emit('loading-ended');
                    });
            }
        },

        created() {
            this.$emit('settings', {title: 'Panel', info: 'Growth over 12 months', configs: []});

            Bus.$on('refresh-widget-' + this.name, () => {
                this.loadData(true);
            });

        },

    }
</script>

<style scoped>
    .chart {
        width: 100%;
        height: 325px;
    }
</style>
